import * as React from "react";
import { Button, makeStyles, Spinner } from "@fluentui/react-components";
import { AuthStatus } from "../types";
import { palette } from "../theme/paebblTheme";

interface AuthScreenProps {
  status: AuthStatus;
  error: string | null;
  onSignIn: () => void;
  onSignOut: () => void;
}

const useStyles = makeStyles({
  root: {
    display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
    minHeight: "100vh", backgroundColor: palette.darkBase, color: palette.white,
    padding: "24px", textAlign: "center",
    fontFamily: "DenimInkRegular, 'Segoe UI', sans-serif",
  },
  title: { fontSize: "20px", fontWeight: 400, marginBottom: "8px" },
  subtitle: { fontSize: "14px", opacity: 0.8, marginBottom: "32px" },
  signInButton: {
    backgroundColor: palette.copperRust, color: palette.darkBase, borderRadius: palette.radiusPill,
    padding: "8px 24px", fontWeight: 400, border: "none",
    ":hover": { backgroundColor: palette.white, color: palette.copperRust },
  },
  error: { color: palette.error, marginTop: "16px", fontSize: "13px" },
  signOutButton: {
    backgroundColor: palette.platinum, color: palette.darkBase, borderRadius: palette.radiusPill,
    padding: "6px 20px", border: "none", marginTop: "16px",
  },
});

const AuthScreen: React.FC<AuthScreenProps> = ({ status, error, onSignIn, onSignOut }) => {
  const styles = useStyles();
  return (
    <div className={styles.root}>
      <div className={styles.title}>Paebbl Data Browser</div>
      <div className={styles.subtitle}>Browse and load data from SageMaker Unified Studio</div>

      {status === "signed_out" && (
        <Button className={styles.signInButton} onClick={onSignIn}>Sign in</Button>
      )}
      {status === "authenticating" && <Spinner label="Signing in..." style={{ fontWeight: 400 }} />}
      {status === "error" && (
        <>
          <div className={styles.error}>{error}</div>
          <Button className={styles.signInButton} onClick={onSignIn} style={{ marginTop: "16px" }}>Try again</Button>
        </>
      )}
      {status === "signed_in" && (
        <Button className={styles.signOutButton} onClick={onSignOut}>Sign out</Button>
      )}
    </div>
  );
};

export default AuthScreen;
